import {
  ActiveState,
  EntityState,
  EntityStore,
  StoreConfig,
} from '@datorama/akita';
import { Injectable } from '@angular/core';
import { TableColumn } from '../../../models/table-column';
import { TextKeys } from '../../../i18n/text-keys';
import { CostCenterFilterOptionsModel } from '../../../models/cost-center/cost-center-filter-options.model';
import { CostCenterListItemModel } from '../../../models/cost-center/cost-center-list-item.model';
import { getTableColumns } from './cost-center-table-columns';

/**
 * Cost Center Entity Store. Used to display list of Cost Centers.
 */
export interface CostCenterItemsState
  extends EntityState<CostCenterListItemModel, number>,
    ActiveState {
  page: number;
  pageSize: number;
  columns: TableColumn[];
  lastPage: boolean;
  filterOptions: CostCenterFilterOptionsModel;
  filterValue: string;
}

// @Injectable({
//     providedIn: 'root'
// })
// @StoreConfig({name: 'cost-center-items'})
export class CostCenterItemsStore extends EntityStore<CostCenterItemsState> {
  constructor(name: string) {
    super(
      {
        page: 0,
        pageSize: 50,
        lastPage: false,
        columns: getTableColumns(),
        filterOptions: {
          number: {
            name: TextKeys.costCenter.numberShort,
            selected: false,
          },
          name: {
            name: TextKeys.costCenter.title,
            selected: false,
          },
        },
        filterValue: '',
      },
      { name }
    );
  }
}
